import { PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as linkifyString from 'linkifyjs/string';
var CommentPipe = /** @class */ (function () {
    function CommentPipe(_domSanitizer) {
        this._domSanitizer = _domSanitizer;
    }
    CommentPipe.prototype.transform = function (value) {
        return this.stylize(value);
    };
    // Modify this method according to your custom logic
    CommentPipe.prototype.stylize = function (str) {
        if (!str) {
            return str;
        }
        var result = this.combineFunctions(str, this.links, this.codePreformatted);
        return this._domSanitizer.sanitize(SecurityContext.URL, this._domSanitizer.bypassSecurityTrustUrl(result));
    };
    CommentPipe.prototype.combineFunctions = function (str) {
        var funcs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            funcs[_i - 1] = arguments[_i];
        }
        return funcs.reduce(function (result, func) { return func(result); }, str);
    };
    /** Converts links to <a> tags */
    CommentPipe.prototype.links = function (str) {
        return linkifyString(str, { className: 'chat-link', defaultProtocol: 'https' });
    };
    /** Converts text within quotes (``) to <pre> tags */
    CommentPipe.prototype.codePreformatted = function (str) {
        var regex = /\`(.*?)\`/;
        var matches = regex.exec(str);
        while (matches) {
            str = str.replace(matches[0], "<pre class=\"chat-pre\">" + matches[1] + "</pre>");
            matches = regex.exec(str);
        }
        return str;
    };
    return CommentPipe;
}());
export { CommentPipe };
